import { Mean, ChangeMeanRequest } from "../../types/rtk/mean/mean";
import { PaymentResponse } from "../../types/rtk/payment/payment";
import { apiSlice } from "../_api/api-slice";

const meanEndpoint = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getMean: build.query<Mean, void>({
      query: () => ({
        url: `/user/mean`,
        method: "get",
      }),
    }),
    postChangeMean: build.mutation<PaymentResponse, ChangeMeanRequest>({
      query: (body) => ({
        url: `/user/mean/change`,
        method: "post",
        body
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetMeanQuery,
  usePostChangeMeanMutation
} = meanEndpoint;